module.exports = __webpack_public_path__ + "static/media/affiliate-course-bg.101ab635.jpeg";